import { useState } from 'react';
import edit from 'common/assets/svg/actions/edit-empty.svg';

import Form from './form';
import useDrawer from 'common/components/drawer/useDrawer';

import TableActions from 'components/layouts/table';
import { Row, Col } from 'reactstrap';
import EnumsDropdown from '../Dropdown';
import Table, { useTable } from 'common/components/table';

const CrewRank = () => {
  const [active, setActive] = useState(null);
  const [isVisibility, setIsVisibility] = useState(false);

  const drawer = useDrawer();

  const table = useTable({
    label: 'crew_rank',
    columns: [
      {
        header: 'Name',
        key: 'name',
        type: 'string',
        className: 'text-start',
        width: 4
      },
      {
        header: 'Department',
        key: 'department',
        type: 'string',
        className: 'text-start',
        width: 2
      },
      {
        header: 'Officer',
        key: 'is_officer',
        type: 'boolean',
        className: 'text-start',
        width: 2
      },
      {
        header: 'Actions',
        key: 'actions',
        field: 'actions',
        className: 'text-center',
        width: 1
      }
    ]
  });

  return (
    <div className="crew-rank">
      <Row className="no-gutters">
        <Col xs={12} className="mb-6 mt-n1">
          <TableActions
            documentTitle="Crew - Rank"
            title="Enums"
            dropdown={<EnumsDropdown />}
            actions={[
              { type: 'search' },
              {
                type: 'add',
                text: 'Add Rank',
                color: 'primary',
                onClick: () => {
                  setActive(null);
                  drawer.open();
                }
              }
            ]}
          />
        </Col>
        <Col xs={12}>
          <Table
            loader
            hideTableFilters
            hideTableSearch
            drawer={
              <Form
                drawer={drawer}
                active={active}
                setIsVisibility={setIsVisibility}
                isVisibility={isVisibility}
                refetchData={table.refetchData}
              />
            }
            rows={{
              name: data => <span className="text-dark fs-12 fw-light ">{data.name}</span>,
              department: data => (
                <span className="text-capitalize text-dark fs-12 ">{data.department || '-'}</span>
              ),
              is_officer: data => <span>{data.is_officer ? 'Yes' : 'No'}</span>,
              actions: {
                options: [
                  {
                    label: 'Edit',
                    icon: edit,
                    onClick: (_, row) => {
                      setIsVisibility(false);
                      setActive(row);
                      drawer.open();
                    }
                  }
                ]
              }
            }}
            {...table}
          />
        </Col>
      </Row>
    </div>
  );
};

export default CrewRank;
